<template>
  <div class="orm-select orm-carCatSelect">
    <div class="orm-searchbar__headline">
      <strong>{{ myLabel }}</strong>
    </div>

    <div class="orm-dateselect orm-row no-margin">
      <div :id="myId" style="width:100%;position:relative">
        <div v-if="myOptions.length <= 0" class="orm-carCatSelect_selected">
          <span
            ><i class="fa fa-spinner-third orm-rotate360"></i>
            {{ i18n("search/label/carselect_loading") || "Lade Modelle" }}</span
          >
        </div>
        <div
          v-else-if="selected"
          @click="
            showOptions = !showOptions;
            open(selected.category);
          "
          class="orm-carCatSelect_selected orm-carCatSelect_selectText"
        >
          <div class="orm-flex">
            <div
              :style="{
                backgroundImage: 'url(' + selected.images[0].image + ')',
              }"
              class="orm-carCatSelect_option_image"
            ></div>
            <span>{{ selected.category }}</span>
          </div>
          <i class="fal fa-chevron-down"></i>
        </div>
        <div
          v-else
          @click="
            showOptions = !showOptions;
            open(i18n('search/label/carselect_select') || 'Modell wählen');
          "
          class="orm-carCatSelect_selected orm-carCatSelect_selectText"
        >
          <span>{{
            i18n("search/label/carselect_select") || "Modell wählen"
          }}</span>
          <i class="fal fa-chevron-down"></i>
        </div>
        <div
          class="orm-carCatSelect_options"
          :style="[showOptions ? { height: 'auto' } : { height: '0' }]"
        >
          <div
            v-for="myOption in myOptions[selectedCarType]"
            :key="myOption"
            :value="myOption.vehicle_category[0].id"
            :selected="myOption.selected"
            @click="
              setCarCategory(myOption);
              select(myOption);
            "
            class="orm-carCatSelect_option"
          >
            <div
              :style="{
                backgroundImage: 'url(' + myOption.images[0].image + ')',
              }"
              class="orm-carCatSelect_option_image"
            ></div>
            <span> {{ myOption.category }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import i18n from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";

export default {
  name: "FormSelectCar",
  emits: ["carSelected"],
  props: {
    myId: {
      type: String,
      required: true,
    },
    myLabel: {
      type: String,
      required: true,
    },
    myOptions: {
      required: true,
    },
    selectedCarType: {
      required: true,
    },
  },
  mixins: [i18n],
  data() {
    return {
      selected: false,
      showOptions: false,
    };
  },
  methods: {
    setCarCategory(group) {
      const obj = {};
      this.selected = group;
      obj[group.vehicle_category[0].id] = true;
      store.dispatch("userSession/SET_CARCATEGORY", obj);
      this.showOptions = false;
      this.$emit("carSelected", group);
    },
    open(selected) {
      buildDataLayer("dropdown_open", selected, "cargroup");
    },
    select(option) {
      buildDataLayer("dropdown_select", option.category, "cargroup");
    },
  },
  watch: {
    selectedCarType: function() {
      this.selected = false;
      this.$emit("carSelected", null);
    },
  },
};
</script>
